import { render, staticRenderFns } from "./Airplane.vue?vue&type=template&id=4a7599a0&scoped=true&"
import script from "./Airplane.vue?vue&type=script&lang=js&"
export * from "./Airplane.vue?vue&type=script&lang=js&"
import style0 from "./Airplane.vue?vue&type=style&index=0&id=4a7599a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7599a0",
  null
  
)

component.options.__file = "Airplane.vue"
export default component.exports